<template>
  <div>
    <FormControl>
      <input type="hidden" v-model="model[name]" class="form-control">
    </FormControl>
  </div>
</template>

<script>
  import FormControl from './FormControl';
  import formControlMixin from "./mixins/form-control.mixin.js";
  
  export default {
    name: 'hidden-input',
    props: ['model', 'name'],
    components: {
      FormControl
    },
    mixins: [formControlMixin],
    methods: {
      getValue() {
        return this.model[this.name];
      }
    }
  }
</script>

<style lang="scss" scoped>
  div {
    display: none;
  }
</style>